// extracted by mini-css-extract-plugin
module.exports = {"submit--position":"Signup_submit--position__3x7QK"};